export default {

  getAccountFirstName(state) {
    return `${state.info?.firstName}`;
  },
  getAccountRep(state) {
    return state.info?.rep;
  },
  getAccounts(state) {
    return state.info?.accounts;
  },
  getAccount(state) {
    return state.info;
  },
  getMemberSince(state){
	  return state.info.memberSince;
  },
 getDataLoaded(state){
	return state.dataLoaded;
 }
};
